import { render, staticRenderFns } from "./report_stu_zhushou_refactor.vue?vue&type=template&id=143b408b&scoped=true&"
import script from "./report_stu_zhushou_refactor.vue?vue&type=script&lang=js&"
export * from "./report_stu_zhushou_refactor.vue?vue&type=script&lang=js&"
import style0 from "./report_stu_zhushou_refactor.vue?vue&type=style&index=0&id=143b408b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b408b",
  null
  
)

export default component.exports